import { SongContext, SongContextType } from '../context/song.context';
import { useContext } from 'react';

const useSongHandler = (): SongContextType => {
    const songContext = useContext(SongContext);
    return songContext;
};

export default useSongHandler;
